import rewards from '../_rewards.json'

export default {
    namespaced: true,
    state: {},
    getters: {
        stepByMinute: () => (minute = 1) => rewards.find(step => {
            if (step.minute.length === 1) {
                return step.minute[0] === minute
            } else if (step.minute.length === 2) {
                return step.minute[0] < minute && step.minute[1] > minute || step.minute[0] === minute || step.minute[1] === minute
            }
        }),

        reward: (state, getters) => (minute = 1) => {
            const deviation = getters.deviation
            const step = getters.stepByMinute(minute)
            if (!step) {
                return null
            } else {
                return deviation === 0 ? step.right : step.left
            }
        },

        deviation (state, getters, rootState) {
            const minute = rootState.control.minute
            const step = getters.stepByMinute(minute)
            return step ? Math.abs(step.regions - rootState.regions.regions.length) : 0
        }
    },
    actions: {
        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        reset () {}
    }
}
